import apiClient, { buildAuthHeaders } from 'services/apiClient';

const emptyFleetStats = {
    totalVehicles: 0,
    operationalVehicles: 0,
    notReadyVehicles: 0,
    modelBreakdown: [],
};

const normalizeCustomer = (customer = {}) => ({
    id: customer.id ?? null,
    name: customer.name || '',
    displayName: customer.display_name || customer.displayName || customer.name || '',
    arabicName: customer.arabic_name || customer.arabicName || '',
    identifier: customer.identifier || '',
    logoUrl: customer.logo_url || customer.logoUrl || '',
    logoAltText: customer.logo_alt_text || customer.logoAltText || '',
});

const normalizeFleetStats = (stats = {}) => ({
    totalVehicles: stats.total_vehicles ?? stats.totalVehicles ?? 0,
    operationalVehicles: stats.operational_vehicles ?? stats.operationalVehicles ?? 0,
    notReadyVehicles: stats.not_ready_vehicles ?? stats.notReadyVehicles ?? 0,
    modelBreakdown: (stats.model_breakdown || stats.modelBreakdown || []).map((item) => ({
        modelId: item.model_id ?? item.modelId ?? null,
        modelName: item.model_name || item.modelName || '',
        totalVehicles: item.total_vehicles ?? item.totalVehicles ?? 0,
        operationalVehicles: item.operational_vehicles ?? item.operationalVehicles ?? 0,
        notReadyVehicles: item.not_ready_vehicles ?? item.notReadyVehicles ?? 0,
    })),
});

export const normalizeCustomerProfile = (payload = {}) => ({
    customer: normalizeCustomer(payload.customer || {}),
    analysisClient: payload.analysis_client || payload.analysisClient || '',
    fleetStats: normalizeFleetStats(payload.fleet_stats || payload.fleetStats || emptyFleetStats),
});

export const getCurrentCustomerProfile = async ({ token }) => {
    const response = await apiClient.get('shiftware/api/v1/customer-profile/me/', {
        headers: buildAuthHeaders(token),
    });
    return normalizeCustomerProfile(response.data || {});
};
